<app-accessibility-toolbar *ngIf="portalLive == true"></app-accessibility-toolbar>

<div class="bulevart-container" (keydown)="onKeyDown($event)" tabindex="0">
    <div class="bulevart-welcome-card d-flex flex-column align-items-start align-self-stretch">
        <div class="bulevart-welcome-card-content d-flex justify-content-between align-items-center align-self-stretch">
            <span>BulevART</span>
        </div>
    </div>

    <div class="bulevart-content d-flex flex-column align-items-start align-self-stretch">
        <div class="bulevart-content-container d-flex flex-column align-self-stretch text-center">

            <!-- Error State -->
            <div *ngIf="error && !isLoading" class="error-container">
                <p>{{ error }}</p>
                <button (click)="loadCategoriesData()" class="retry-button">Retry</button>
            </div>

            <!-- Content -->
            <div *ngIf="!isLoading && !error">
                <div *ngFor="let category of categories">
                    <div class="century-header">
                        <h1>{{ category.title }}</h1>
                    </div>

                    <!-- Loop through subcategories -->
                    <div *ngFor="let subcategory of category.subcategories">
                        <!-- Subcategory as full-width section if it has no images -->
                        <div *ngIf="!subcategory.images || subcategory.images.length === 0" class="full-width-section">
                            <h2>{{ subcategory.title }}</h2>
                            <p>{{ subcategory.description }}</p>
                        </div>

                        <!-- Subcategory with images in grid -->
                        <div *ngIf="subcategory.images && subcategory.images.length > 0" class="section mb-5">
                            <div class="section-header">
                                <h2>{{ subcategory.title }}</h2>
                                <p>{{ subcategory.description }}</p>
                            </div>

                            <!-- Images for subcategory -->
                            <div class="image-item"
                                *ngFor="let image of getVisibleImages(subcategory.images, getSubcategoryId(category.title, subcategory.title))">
                                <div class="image-wrapper" (click)="openModal(image)">
                                    <img [src]="getImageUrl(image, 'big_size')" [alt]="image.original_filename">
                                    <p class="caption">{{ image.original_filename }}</p>
                                </div>
                            </div>

                            <!-- Load More / Show Less Button for Subcategory -->
                            <div class="load-more-container"
                                *ngIf="shouldShowLoadMoreButton(subcategory.images, getSubcategoryId(category.title, subcategory.title)) || shouldShowShowLessButton(subcategory.images, getSubcategoryId(category.title, subcategory.title))">
                                <button class="load-more-btn"
                                    *ngIf="shouldShowLoadMoreButton(subcategory.images, getSubcategoryId(category.title, subcategory.title))"
                                    (click)="loadMoreImages(getSubcategoryId(category.title, subcategory.title), subcategory.images.length)">
                                    Încarcă mai multe ({{ getRemainingImagesCount(subcategory.images,
                                    getSubcategoryId(category.title, subcategory.title)) }})
                                </button>
                                <button class="show-less-btn"
                                    *ngIf="shouldShowShowLessButton(subcategory.images, getSubcategoryId(category.title, subcategory.title))"
                                    (click)="showLessImages(getSubcategoryId(category.title, subcategory.title))">
                                    Încarcă mai puține (-10)
                                </button>
                            </div>
                        </div>

                        <!-- Loop through tertiary categories -->
                        <div *ngFor="let tertiary of subcategory.tertiary_categories" class="section mb-5">
                            <div class="section-header">
                                <h3>{{ tertiary.title }}</h3>
                                <p>{{ tertiary.description }}</p>
                            </div>

                            <!-- Images for tertiary category -->
                            <div class="image-item"
                                *ngFor="let image of getVisibleImages(tertiary.images, getTertiaryId(category.title, subcategory.title, tertiary.title))">
                                <div class="image-wrapper" (click)="openModal(image)">
                                    <img [src]="getImageUrl(image)" [alt]="image.original_filename">
                                    <p class="caption">{{ image.original_filename }}</p>
                                </div>
                            </div>

                            <!-- Load More / Show Less Button for Tertiary Category -->
                            <div class="load-more-container"
                                *ngIf="shouldShowLoadMoreButton(tertiary.images, getTertiaryId(category.title, subcategory.title, tertiary.title)) || shouldShowShowLessButton(tertiary.images, getTertiaryId(category.title, subcategory.title, tertiary.title))">
                                <button class="load-more-btn"
                                    *ngIf="shouldShowLoadMoreButton(tertiary.images, getTertiaryId(category.title, subcategory.title, tertiary.title))"
                                    (click)="loadMoreImages(getTertiaryId(category.title, subcategory.title, tertiary.title), tertiary.images.length)">
                                    Load More ({{ getRemainingImagesCount(tertiary.images, getTertiaryId(category.title,
                                    subcategory.title, tertiary.title)) }})
                                </button>
                                <button class="show-less-btn"
                                    *ngIf="shouldShowShowLessButton(tertiary.images, getTertiaryId(category.title, subcategory.title, tertiary.title))"
                                    (click)="showLessImages(getTertiaryId(category.title, subcategory.title, tertiary.title))">
                                    Show Less (-10)
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer">
        <app-footer></app-footer>
    </div>
</div>

<!-- Loading Spinner -->
<div class="section-spinner position-fixed" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/images/logo-ps4-v2.png" height="50%" width="50%" alt="DGASPC" />
        <mat-spinner class="mt-2"></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>

<!-- Image Modal -->
<div class="image-modal" *ngIf="showModal" (click)="onModalBackdropClick($event)">
    <div class="modal-content">
        <button class="close-button" (click)="closeModal()">
            <span>&times;</span>
        </button>

        <!-- Previous Arrow -->
        <button class="nav-arrow nav-arrow-left" *ngIf="hasPreviousImage()" (click)="previousImage()">
            <span>&#8249;</span>
        </button>

        <!-- Next Arrow -->
        <button class="nav-arrow nav-arrow-right" *ngIf="hasNextImage()" (click)="nextImage()">
            <span>&#8250;</span>
        </button>

        <div class="modal-image-container">
            <img [src]="getImageUrl(selectedImage)" [alt]="selectedImage?.original_filename" class="modal-image">
        </div>

        <div class="modal-caption">
            <span class="group-title">{{ currentGroupTitle }}</span>
            <span class="image-counter">{{ currentImageIndex + 1 }} / {{ currentGroupImages.length }}</span>
            <span class="image-name">{{ selectedImage?.original_filename }}</span>
        </div>
    </div>
</div>